// extracted by mini-css-extract-plugin
export default {"formContainer":"Usuarios_formContainer__GyVr0","addButton":"Usuarios_addButton__sY7Al"};